import React from 'react';
import { Text, View } from 'react-native';
import { StackHeaderProps } from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { CONTENT_MAX_WIDTH, TYPOGRAPHY } from '../assets/theme';
import { makeStyles } from '../theme/ThemeContext';
import { useLayout } from '../theme/useLayout';
import IconCircleButton from '../components/ui/IconCircleButton';
import TopNav from './TopNav';

/**
 * Header of pushed screens (client profile, order detail…): on desktop the top navigation
 * stays visible with a back row underneath; on mobile a compact bar with a round back button.
 */
export default function DetailHeader({ navigation, options, back }: StackHeaderProps) {
  const styles = useStyles();
  const insets = useSafeAreaInsets();
  const { isDesktop, gutter } = useLayout();
  const title = typeof options.title === 'string' ? options.title : '';
  const goBack = () => {
    if (back) navigation.goBack();
    else navigation.navigate('Main');
  };

  if (isDesktop) {
    return (
      <View>
        <TopNav />
        <View style={[styles.backRow, { paddingHorizontal: gutter }]}>
          <View style={styles.backRowInner}>
            <IconCircleButton icon="chevron-left" onPress={goBack} accessibilityLabel="Retour" size={36} />
            <Text style={styles.desktopTitle} numberOfLines={1} accessibilityRole="header">{title}</Text>
          </View>
        </View>
      </View>
    );
  }

  return (
    <View style={[styles.mobileBar, { paddingTop: insets.top }]}>
      <IconCircleButton icon="chevron-left" onPress={goBack} accessibilityLabel="Retour" size={36} />
      <Text style={styles.mobileTitle} numberOfLines={1} accessibilityRole="header">{title}</Text>
      <View style={styles.spacer} />
    </View>
  );
}

const useStyles = makeStyles((c) => ({
  backRow: { backgroundColor: c.background, paddingTop: 20 },
  backRowInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 14,
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH,
    alignSelf: 'center',
  },
  desktopTitle: { ...TYPOGRAPHY.title, color: c.textPrimary, flexShrink: 1 },
  mobileBar: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    minHeight: 60,
    paddingHorizontal: 12,
    backgroundColor: c.background,
    borderBottomWidth: 1,
    borderBottomColor: c.divider,
  },
  mobileTitle: { flex: 1, textAlign: 'center', fontSize: 16, fontWeight: '700', color: c.textPrimary },
  spacer: { width: 36 },
}));
